module.exports = __webpack_public_path__ + "img/chart.c6d44c1.png";